import React from 'react';

const DonutIcon = (props) => (
  <svg {...props} viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='5.5' cy='5.5' r='4' stroke={props.fill} strokeWidth='3' />
  </svg>
);

export default DonutIcon;
